<form [formGroup]='formGroup' class='mb-4'>

  <div *ngIf='!domain && domainLabel' class='w-100 mb-3'>
    <label class="form-label" for='domain'>{{ domainLabel }}</label>
    <input autocomplete='off'
           class='form-control form-control-sm'
           formControlName='domain'
           id='domain'
           type='text'>
  </div>

  <div *ngIf='emailLabel' class='w-100 mb-3'>
    <label class="form-label" for='email'>{{ emailLabel }}</label>
    <input autocomplete='off'
           class='form-control form-control-sm'
           formControlName='email'
           id='email'
           type='email'>
  </div>

  <div *ngIf='tokenLabel' class='w-100 mb-3'>
    <pt-input-label
      [isRequired]='true'
      [label]="tokenLabel"
      inputId='token'
      style='display: contents'
    ></pt-input-label>
    <input autocomplete='off'
           class='form-control form-control-sm'
           formControlName='token'
           id='token'
           type='text'>
  </div>
  <pt-input-confirm-password
    [confirmPasswordLabel]="confirmPasswordLabel"
    [controlName]="'password'"
    [passwordLabel]="passwordLabel"
    formControlName='password'
  ></pt-input-confirm-password>

  <ngb-alert *ngIf='message' [animation]='true' [dismissible]='false' [type]="'warning'">{{ message }}</ngb-alert>
</form>

<pt-sign-actions
  (onCancel)='onCancel.emit()'
  (onConfirm)='confirm()'
  [cancelLabel]='cancelLabel'
  [confirmLabel]='confirmLabel'
  [enabledConfirm]='formGroup.valid && !loading'
  [showCancel]='true'
  [showConfirm]='true'>
</pt-sign-actions>
